import script from "./VerificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationModal.vue?vue&type=style&index=0&id=6b2da28b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2da28b"]])

export default __exports__